import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { CardContent, CardHeader, Divider, Grid } from '@material-ui/core';
import InputMask from 'react-input-mask';
import { SelectValidator, TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import MenuItem from '@material-ui/core/MenuItem';
import { SexoValues } from '../../../../values/SexoValues';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import Fade from '@material-ui/core/Fade';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import { Visibility, VisibilityOff } from '@material-ui/icons';


function UsuarioRegisterInfo(props) {
  const {
    usuario,
    setUsuario,
    setShowMessageSnack,
    setMessageSnack,
    setTypeSnack,
    tipoUsuarios,
    edicao
  } = props;
  const [nome, setNome] = useState(props.usuario.nome);
  const [nomeFantasia, setNomeFantasia] = useState(props.usuario.nomeFantasia);
  const [cpfCnpj, setCpfCnpj] = useState(props.usuario.cpfCnpj);
  const [email, setEmail] = useState(props.usuario.email);
  const [login, setLogin] = useState(props.usuario.login);
  const [sexo, setSexo] = useState(props.usuario.sexo);
  const [dataNascimento, setDataNascimento] = useState(props.usuario.dataNascimento);
  const [tipoUsuario, setTipoUsuario] = useState(props.usuario.idTipoUsuario);
  const [maskCpf] = useState('999.999.999-99');
  const [maskCnae] = useState('9999-9/99');
  const [openDialogFinish, setOpenDialogFinish] = React.useState(false);
  const [senha, setSenha] = useState(props.usuario.senha);
  const [replicaSenha, setReplicaSenha] = useState('');
  const [mostrarSenha, setMostrarSenha] = useState(false);
  const [mostrarReplicaSenha, setMostrarReplicaSenha] = useState(false);
  const [refreshState, setRefreshState] = useState(new Date());

  useEffect(() => {
    async function validatorSenha() {
      ValidatorForm.addValidationRule('isPasswordMatch', (value) => {
        return value == senha;
      });
    }
    validatorSenha()
  }, [replicaSenha]);

  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <Typography
        component="div"
        role="tabpanel"
        hidden={value !== index}
        id={`scrollable-force-tabpanel-${index}`}
        aria-labelledby={`scrollable-force-tab-${index}`}
        {...other}
      >
        <Box p={3}>{children}</Box>
      </Typography>
    );
  }

  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
  };

  function a11yProps(index) {
    return {
      id: `scrollable-force-tab-${index}`,
      'aria-controls': `scrollable-force-tabpanel-${index}`,
    };
  }


  function abrirDialogFinish (e) {
    setOpenDialogFinish(!openDialogFinish);
  }



  function errosForms() {
    setMessageSnack("Existem erros no formulário! Verifique e tente novamente");
    setTypeSnack('error');
    setShowMessageSnack(true);
  }

  const handleChangeDatNascimento = date => {
    usuario.dataNascimento = date;
    setUsuario(usuario);
    setDataNascimento(date);
  };

  function modificarValores(order, value){
    switch (order) {
      case 0:
        usuario.nome = value;
        setUsuario(usuario);
        setNome(value);
        break;
      case 1:
        usuario.nomeFantasia = value;
        setUsuario(usuario);
        setNomeFantasia(value);
        break;
      case 2:
        usuario.email = value;
        setUsuario(usuario);
        setEmail(value);
        break;
      case 3:
        usuario.cpfCnpj = value;
        setUsuario(usuario);
        setCpfCnpj(value);
        break;
      case 4:
        usuario.sexo = value;
        setUsuario(usuario);
        setSexo(value);
        break;
      case 5:
        usuario.dataNascimento = value;
        setUsuario(usuario);
        setDataNascimento(value);
        break;
      case 6:
        usuario.idTipoUsuario = value;
        setUsuario(usuario);
        setTipoUsuario(value);
        break;
      case 7:
        usuario.login = value;
        setUsuario(usuario);
        setLogin(value);
        break;
      case 8:
        usuario.senha = value;
        setUsuario(usuario);
        setSenha(value);
        break;
    }
    console.log(usuario);
  }

  const handleClickShowPassword = () => {
    setMostrarSenha(!mostrarSenha);
  };

  const handleClickShowPasswordAgain = () => {
    setMostrarReplicaSenha(!mostrarReplicaSenha);
  };

  const handleMouseDownPassword = event => {
    event.preventDefault();
  };

  function onChangeReplicaSenha(replica) {
    setReplicaSenha(replica);
    ValidatorForm.addValidationRule('isPasswordMatch', (value) => {
      return value == senha;
    });
  }


  return (
    <div

    >
      <CardHeader
        subheader="Informe as seguintes informações do usuário"
        title="Usuário"
      />
      <CardContent>
        <Grid
          container
          spacing={3}
        >
          <Grid
            item
            md={6}
            xs={12}
          >
            <TextValidator
              fullWidth
              label="Nome completo"
              helperText="Insira o nome completo do usuário."
              margin="dense"
              name="nome_usuario"
              onChange={e => modificarValores(0, e.target.value)}
              value={nome}
              variant="outlined"
              validators={['required', 'minStringLength:3', 'maxStringLength:155']}
              errorMessages={['Insira o nome completo do usuário.', 'Nome muito curto.', 'Nome muito longo.']}
            />
          </Grid>
          <Grid
            item
            md={6}
            xs={12}
          >
            <TextValidator
              fullWidth
              label="Apelido"
              helperText="Insira um apelido para o usuário."
              margin="dense"
              name="nomeFantasia"
              onChange={e => modificarValores(1, e.target.value)}
              value={nomeFantasia}
              variant="outlined"
              validators={['required', 'maxStringLength:20']}
              errorMessages={['Insira um apelido para o usuário.', 'Apelido muito longo.']}
            />
          </Grid>
          <Grid
            item
            md={6}
            xs={12}
          >
            <TextValidator
              fullWidth
              label="Email"
              helperText="Insira o email do usuário."
              margin="dense"
              name="email"
              onChange={e => modificarValores(2, e.target.value)}
              value={email}
              variant="outlined"
              validators={['required', 'isEmail']}
              errorMessages={['Insira o email do usuário.', 'Informe um email válido!']}
            />
          </Grid>
          <Grid
            item
            md={3}
            xs={12}
          >
            <TextValidator
              fullWidth
              label="Login"
              helperText="Insira o login do usuário."
              margin="dense"
              name="login"
              onChange={e => modificarValores(7, e.target.value)}
              value={login}
              variant="outlined"
              validators={['required', 'minStringLength:3']}
              errorMessages={['Insira o login do usuário.', 'Login muito curto.']}
            />
          </Grid>
          <Grid
            item
            md={3}
            xs={12}
          >

            <InputMask
              mask={maskCpf}
              value={cpfCnpj}
              onChange={e => modificarValores(3, e.target.value)}
            >
              {
                (inputProps) =>
                  <TextValidator
                    fullWidth
                    label="CPF"
                    margin="dense"
                    name="cnpj"
                    onChange={inputProps.onChange}
                    type="text"
                    variant="outlined"
                    helperText="Insira o CPF do usuário."
                    validators={['required']}
                    errorMessages={['Insira o CPF do usuário.']  }
                  />

              }
            </InputMask>
          </Grid>
          <Grid
            item
            md={4}
            xs={12}
          >
            <SelectValidator
              fullWidth
              helperText="Insira o sexo do usuário."
              label="Sexo"
              margin="dense"
              name="sexo"
              onChange={e => modificarValores(4, e.target.value)}
              value={sexo}
              variant="outlined"
              validators={['required']}
              errorMessages={['Insira o sexo do usuário.']}
            >
              {SexoValues.map((sexo, index) => (
                <MenuItem key={index} value={sexo.value}>{sexo.label}</MenuItem>
              ))}

            </SelectValidator>

          </Grid>
          <Grid
            item
            lg={4}
            md={4}
            xs={12}
          >
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <Grid container justify="space-around">
                <KeyboardDatePicker
                  fullWidth
                  margin="dense"
                  inputVariant="outlined"
                  orientation="landscape"
                  id="dataNascimento"
                  label="Data de Nascimento"
                  helperText={'Insira a data de nascimento'}
                  format="dd/MM/yyyy"
                  size='small'
                  value={dataNascimento}
                  onChange={handleChangeDatNascimento}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                  InputAdornmentProps={{ position: "end" }}
                />

              </Grid>
            </MuiPickersUtilsProvider>
          </Grid>
          <Grid
            item
            md={4}
            xs={12}
          >
            <SelectValidator
              fullWidth
              helperText="Insira o tipo do usuário."
              label="Tipo de usuário"
              margin="dense"
              name="tipo_usuario"
              onChange={e => modificarValores(6, e.target.value)}
              value={tipoUsuario}
              variant="outlined"
              validators={['required']}
              errorMessages={['Insira o sexo do usuário.']}
            >
              {tipoUsuarios.result.map((tipoUsuario01, index) => (
                <MenuItem key={index} value={tipoUsuario01.idTipoUsuario}>{tipoUsuario01.descricao}</MenuItem>
              ))}

            </SelectValidator>

          </Grid>
          <Fade
            in={ !edicao }
            style={{
              transitionDelay: '0ms',
            }}
            unmountOnExit
          >
            <div>
              <CardHeader
                subheader="Informe uma senha para o usuário"
                title="Senha"
              />
              <CardContent>
                <Grid
                  container
                  spacing={3}
                >
                  <Grid
                    item
                    md={6}
                    xs={12}
                  >
                    <TextValidator
                      id="outlined-adornment-password"
                      variant="outlined"
                      margin="dense"
                      fullWidth
                      value={senha}
                      type={mostrarSenha ? 'text' : 'password'}
                      label="Informe a senha"
                      onChange={e => modificarValores(8, e.target.value)}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              edge="end"
                              aria-label="toggle password visibility"
                              onClick={handleClickShowPassword}
                              onMouseDown={handleMouseDownPassword}
                            >
                              {mostrarSenha ? <VisibilityOff/> : <Visibility/>}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      helperText="Insira a senha de acesso ao sistema do usuario."
                      validators={['required', 'minStringLength:6']}
                      errorMessages={['Informe a senha', 'Senha muito curta!']}
                    />

                  </Grid>
                  <Grid
                    item
                    md={6}
                    xs={12}
                  >
                    <TextValidator
                      id="outlined-adornment-password"
                      variant="outlined"
                      margin="dense"
                      fullWidth
                      value={replicaSenha}
                      type={mostrarReplicaSenha ? 'text' : 'password'}
                      label="Digite a senha novamente!"
                      onChange={e => onChangeReplicaSenha(e.target.value)}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              edge="end"
                              aria-label="toggle password visibility"
                              onClick={handleClickShowPasswordAgain}
                              onMouseDown={handleMouseDownPassword}
                            >
                              {mostrarReplicaSenha ? <VisibilityOff/> : <Visibility/>}
                            </IconButton>

                          </InputAdornment>
                        ),
                      }}
                      helperText="Insira a senha novamente."
                      validators={['required', 'isPasswordMatch']}
                      errorMessages={['Informe a senha novamente', 'As senhas não são iguais!']}
                    />
                  </Grid>
                </Grid>
              </CardContent>
            </div>
          </Fade>
        </Grid>
      </CardContent>
      <Divider />

    </div>
  );
};

UsuarioRegisterInfo.propTypes = {
  className: PropTypes.string,
  usuario: PropTypes.object.isRequired,
  setUsuario: PropTypes.object.isRequired
};

export default UsuarioRegisterInfo;


